up.compiler('.js-plan_form_copy_access_select', function (select) {
  select.dataset.value = select.value

  up.on(select, 'change', function () {
    select.dataset.value = select.value
  })
})
